import { api_url } from "../../utils/constants";
const axios = require("axios").default;

/**
 * Public — get company domain, code, and optionally validate a program ID.
 * GET /public/GetCompanyInfo?id=5&programId=7
 */
export const getCompanyInfo = (companyId, programId) => {
    const params = { id: companyId };
    if (programId) params.programId = programId;

    return new Promise((resolve, reject) => {
        axios({
            method: "GET",
            url: api_url + "/public/GetCompanyInfo",
            params,
        })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
};

/**
 * Authenticated — get the logged-in employee's corporate profile.
 * GET /GetMyCorpProfile
 */
export const getMyCorpProfile = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: "GET",
            url: api_url + "/GetMyCorpProfile",
            headers: {
                Authorization: "Bearer " + window.localStorage.getItem("jwtToken"),
            },
        })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
};

/**
 * Authenticated — get the employee's corporate sessions.
 * GET /GetMyCorporateSessions
 */
export const getMyCorporateSessions = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: "GET",
            url: api_url + "/GetMyCorporateSessions",
            headers: {
                Authorization: "Bearer " + window.localStorage.getItem("jwtToken"),
            },
        })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
};

// ─── Session Enrollment APIs ───────────────────────────────────────────────

/**
 * Authenticated — enroll in a corporate session.
 * POST /EnrollCorporateSession  { sessionId, notes? }
 */
export const enrollCorporateSession = (sessionId, notes) => {
    return new Promise((resolve, reject) => {
        axios({
            method: "POST",
            url: api_url + "/EnrollCorporateSession",
            data: JSON.stringify({ sessionId, notes }),
            headers: {
                Authorization: "Bearer " + window.localStorage.getItem("jwtToken"),
                "Content-Type": "application/json",
            },
        })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
};

/**
 * Authenticated — update enrollment status (enrolled | attended | missed | cancelled).
 * PUT /UpdateCorporateSessionEnrollment  { sessionId, status, notes? }
 */
export const updateSessionEnrollment = (sessionId, status, notes) => {
    return new Promise((resolve, reject) => {
        axios({
            method: "PUT",
            url: api_url + "/UpdateCorporateSessionEnrollment",
            data: JSON.stringify({ sessionId, status, notes }),
            headers: {
                Authorization: "Bearer " + window.localStorage.getItem("jwtToken"),
                "Content-Type": "application/json",
            },
        })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
};

/**
 * Authenticated — cancel (delete) a session enrollment.
 * DELETE /CancelCorporateSessionEnrollment?sessionId=
 */
export const cancelSessionEnrollment = (sessionId) => {
    return new Promise((resolve, reject) => {
        axios({
            method: "DELETE",
            url: api_url + "/CancelCorporateSessionEnrollment",
            params: { sessionId },
            headers: {
                Authorization: "Bearer " + window.localStorage.getItem("jwtToken"),
            },
        })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
};

/**
 * Authenticated — get all session enrollments for the current user.
 * GET /GetMySessionEnrollments
 */
export const getMySessionEnrollments = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: "GET",
            url: api_url + "/GetMySessionEnrollments",
            headers: {
                Authorization: "Bearer " + window.localStorage.getItem("jwtToken"),
            },
        })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
};

// ─── Registration ──────────────────────────────────────────────────────────

/**
 * Public — register a corporate user.
 */
export const registerCorporateUser = (payload) => {
    return new Promise((resolve, reject) => {
        axios({
            method: "POST",
            url: api_url + "/public/corporate/register",
            data: JSON.stringify(payload),
            headers: { "Content-Type": "application/json" },
        })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
};
